(function () {
  "use strict";

  angular
    .module("alk.forms")
    .directive("alkLogin", alkLogin);

  alkLogin.$inject = [];

  function alkLogin() {

    var directive = {
      template: require("./login.html"),
      restrict: "E",
      scope: {
        controllerName: "@",
        marketingLink: "@"
      },
      //Use the passed-in controller-name attribute to create its controller
      controller: ["$controller", "$scope", function($controller, $scope) {
        var c = $controller($scope.controllerName, {$scope: $scope});
        return c;
      }]
    };

    return directive;
  }

})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-forms/login/login.directive.js